'use client'

import axios from 'axios'

// This may eventually replace fetch, but for now it is only used for the import
// so that we can have an upload progress bar.

/**
 * Axios helper that adds the user token to the request
 * @param {*} path - the api endpoint path excluding the base url
 * @param {*} options - the fetch options
 * @param {*} user - the user containing the user.token
 * @returns the fetch response
 */
export default async function axiosHelper(
  path,
  options,
  context,
  setContentType = true,
  url = 'api',
) {
  if (options.headers) {
    options.headers['Authorization'] = 'Bearer ' + context.user.token
    if (!options.headers['Content-Type'] && setContentType) {
      options.headers['Content-Type'] = 'application/json'
    }
  } else {
    const headers = { Authorization: 'Bearer ' + context.user.token }
    if (setContentType) headers['Content-Type'] = 'application/json'
    options.headers = headers
  }

  try {
    let urlBase
    switch (url) {
      case 'slack':
        urlBase = process.env.NEXT_PUBLIC_SLACK_URL
        break
      case 'billing':
        urlBase = process.env.NEXT_PUBLIC_BILLING_URL
        break
      default:
        urlBase = process.env.NEXT_PUBLIC_API_URL
        break
    }
    return await axios({
      url: urlBase + path,
      ...options,
    })
  } catch (err) {
    // Handle 401 Unauthorized
    if (err.response?.status === 401) {
      // Redirect to login, but return the real 401 response so callers that destructure
      // `const { data } = await axiosHelper(...)` get a 401 response instead of crashing
      // on `undefined`.
      context.router.push(
        '/?from=' + encodeURIComponent(context.pathname),
        'replace',
      )
      return err.response
    }

    console.error('Axios Error:', err)
    throw err
  }
}
